export { default } from './CoverTitle';
